import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { of } from 'rxjs';

export const StudentOrGuestGuard: CanActivateFn = (route, state) => {
    const router: Router = inject(Router);
    const authService: AuthService = inject(AuthService);
    const platformId = inject(PLATFORM_ID);

    if (!isPlatformBrowser(platformId)) {
        return of(true);
    }

    const isLoggedIn = !!authService.getToken();
    const userRole = authService.getRole();

    if (!isLoggedIn) {
        // Allow access for guests (not logged in)
        return of(true);
    }

    if (userRole === 'student') {
        // Allow access for logged-in students
        return of(true);
    }

    // For any other logged-in user (e.g., tutor), redirect
    const urlTree = router.parseUrl('');
    return of(urlTree);
};
